import React from 'react';
import PropTypes from 'prop-types';

export default class TotalComponentProto extends React.Component {

    static propTypes = {
        renderMode: PropTypes.oneOf(['list','view']).isRequired,
        value: PropTypes.any,
    };

    render() {
        const classes = Classes('gd-field-total', 'ui5-txt-less-important-small', this.props.renderMode, this.props.className, {
            'not-set': _.isNil(this.props.value)
        });

        let res;
        switch (this.props.renderMode) {
            case 'list':
            case 'view':
                res = <div className={classes}>{!!this.props.value ? this.props.value : ''}</div>;
                break;
        }

        return res;
    }
}
